<div class="banner">
  <h1>Contacts</h1>
</div>
<div class="container mt-4">
  <h3>Contacts</h3>
  <fgb-contacts-management></fgb-contacts-management>
</div>
